import _ from 'lodash';
import { AnyAction } from 'redux';
import ShoppingCart from 'src/entities/cart/response/ShoppingCart';
import {
    FAILURE_ORDERING_CALC,
    REQUEST_ORDERING_CALC,
    RESET_SHOPPING_CART,
    SUCCESS_ORDERING_CALC,
    SUCCESS_SUBMIT_BOOKING,
} from 'src/store/cart/actions';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';

export type CartState = SingleEntityState<ShoppingCart>;

/**
 * Reducer that manages the state of shopping cart
 */
function cartReducer(state: CartState = singleEntityDefaultState(), action: AnyAction): CartState {
    switch (action.type) {
        case RESET_SHOPPING_CART:
            return singleEntityDefaultState();
        case REQUEST_ORDERING_CALC:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDERING_CALC:
            return _.assign({}, state, {
                isFetching: false,
                content: {
                    ...action.response.data,
                    containsOrderDirectlyProduct: action.containsOrderDirectlyProduct,
                    selfRebateEchoTrusted: true,
                },
                error: undefined,
            });
        case SUCCESS_SUBMIT_BOOKING:
            return _.assign({}, state, { isFetching: false, content: undefined, error: undefined });
        case FAILURE_ORDERING_CALC:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export default cartReducer;
